export default __webpack_public_path__ + "static/media/Arrow Right.decc3cb7.svg";